import React from 'react'
import MySelect from '../formGroup/MySelect'
import { useTriggerChangeHook } from '../../hooks/triggerChangeHook'
import { IStep2ProfessionalSubCategory } from '../../interfaces/Step2'

const Step2ProfessionalSubCategory = (props: IStep2ProfessionalSubCategory) => {
  const { professionSubcategories, register, errors, onChange } = props
  const professionalSubcategory = useTriggerChangeHook(
    'professional_subcategory'
  )

  return (
    <MySelect
      options={professionSubcategories}
      value={professionalSubcategory || ''}
      register={register({ required: true })}
      name="professional_subcategory"
      id="professional_subcategory"
      error={errors.professional_subcategory}
      label="Catégorie professionnelle"
      required
      onChange={onChange}
    />
  )
}

export default Step2ProfessionalSubCategory
